export const selectAnswers = (state) => state.answers.toJS();

export const selectAnswerByElementName = (state, elementName) => {
  const answerFound = state.answers.filter((answer) => answer.get('name') === elementName).first();
  return answerFound && answerFound().toJS();
};

export const hasAnswer = (state, page) => {
  const isAnswered = state.answers.find((answer) => {
    return answer.get('pageId') === page?.id || answer.get('originalPageId') === page?.originalId;
  });

  return !!isAnswered;
};
